<template>
    <v-tooltip top :disabled="!tooltip" max-width="280">
        <template #activator="{ on, attrs }">
            <div class="score-bar" :class="{ 'score-bar--dense': dense }" v-bind="attrs" v-on="on">
                <div class="score-bar__track">
                    <div v-if="value !== null && value !== undefined" class="score-bar__fill"
                        :style="{ width: Math.max(0, Math.min(100, value)) + '%' }" />
                </div>
                <span class="score-bar__value" :class="{ 'font-weight-bold': bold }">
                    {{ value === null || value === undefined ? '–' : Math.round(value) }}
                </span>
            </div>
        </template>
        <span>{{ tooltip }}</span>
    </v-tooltip>
</template>

<script>
// One hue for magnitude: the fill and its lighter track come from the same
// blue ramp, so a score reads as "how much" and never as a category.
export default {
    name: 'ScoreBar',
    props: {
        value: { type: Number, default: null },
        tooltip: { type: String, default: '' },
        dense: { type: Boolean, default: false },
        bold: { type: Boolean, default: false },
    },
}
</script>

<style scoped>
.score-bar {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 90px;
    padding: 4px 0;
}

.score-bar__track {
    flex: 1;
    height: 8px;
    border-radius: 4px;
    background: #cde2fb;
    overflow: hidden;
}

.score-bar--dense .score-bar__track {
    height: 6px;
}

.score-bar__fill {
    height: 100%;
    border-radius: 4px;
    background: #2a78d6;
}

.score-bar__value {
    width: 26px;
    text-align: right;
    font-size: 13px;
    font-variant-numeric: tabular-nums;
    color: rgba(0, 0, 0, 0.87);
}
</style>
